/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useMemo, useCallback, useState } from 'react'
import { Checkbox, Collapse, Input, Button, Popover, Switch } from 'antd'
import R from 'ramda'
import styled from '@emotion/styled'
import { connect } from 'react-redux'
import {
  getPermitActions,
  getEnvConfig,
  getCompanyNameMap,
  getStations,
} from 'core'
import { hasAccesPermits } from 'core/utils'

const CheckboxListDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-content: baseline;
  max-height: 300px;
  overflow: auto;
  height: auto;
`

const setterFunc = id => (ids = []) =>
  ids.includes(id) ? ids.filter(i => i !== id) : [id, ...ids]

// const setterFuncAll=(ids=[])=> ids

const getDataMap = data => {
  const sd = {}
  data.forEach(dt => {
    const { id } = dt
    const oid = id.substr(
      0,
      id.indexOf('$$') === -1 ? id.length : id.indexOf('$$')
    )
    if (sd[oid]) {
      const ad = sd[oid]
      ad.push(dt)
    } else {
      sd[oid] = [dt]
    }
  })
  //  setDataMap(sd)
  return sd
}

const RoleTypeSelection = ({
  data,
  selectedIds,
  setSelectedIds,
  toDisplay,
  toId,
  acceptFilter,
  resourceType = 'company',
  height,
  idNameMap,
  hasCopyAddFunctinality,
  stations,
  companyNameMap,
  ...props
}) => {
  const onChange = useCallback(id => _val => setSelectedIds(setterFunc(id)), [
    setSelectedIds,
  ])

  const stationNameMap = useMemo(
    _ =>
      R.reduce(
        (a, b) => ({ ...a, ...b }),
        {},
        stations.map(s => ({ [s.station]: s.stationName }))
      ),
    [stations]
  )

  const dataMap = useMemo(_ => getDataMap(data), [data])

  const getCheckbox = useCallback(
    (sameId, display) => {
      return (
        <div>
          <Checkbox
            checked={selectedIds.includes(sameId)}
            onChange={onChange(sameId)}
            key={sameId}
          >
            {display || (
              <strike>{sameId.substr(sameId.lastIndexOf('$') + 1)}</strike>
            )}
          </Checkbox>
        </div>
      )
    },
    [onChange, selectedIds]
  )

  const [showAll, setShowAll] = useState({})
  const [fuzzyFilter, setFuzzyFilter] = useState({})

  const getPrifixId = firstId => {
    return firstId.substring(
      0,
      firstId.indexOf('$$') >= 0 ? firstId.indexOf('$$') : firstId.length
    )
  }

  const resourceTypeSort = useCallback(
    roles => {
      return R.compose(
        R.sortBy(r => idNameMap[r.resources] || r.resources),
        R.filter(r => {
          const { id, resources } = r
          const curPreId = getPrifixId(id)
          const visibleCurrent = Object.keys(showAll)
            .filter(f => (showAll[f] === undefined ? true : showAll[f]))
            // .map(firstId => getPrifixId(firstId))
            .filter(f => {
              return f === curPreId
            })

          if (
            visibleCurrent.includes(curPreId) ||
            showAll[curPreId] === undefined
          )
            return true

          const visibleSelected = selectedIds.filter(
            f => !visibleCurrent.includes(getPrifixId(f))
          )

          return visibleSelected.includes(id)
        }),
        // R.map(r => {

        //   // return selectedIds.includes(r.id)
        //   return r
        // }),
        R.filter(r => {
          const { id, resources } = r
          const curPreId = getPrifixId(id)
          const filterText = fuzzyFilter[curPreId] || ''
          return (idNameMap[resources] + '' + resources)
            ?.toLowerCase()
            .includes(filterText.toLowerCase())
        }),
        R.map(r => ({
          id: r.id,
          resources:
            resourceType === 'company'
              ? r.resources.company && r.resources.company[0]
              : r.resources.station && r.resources.station[0],
          displayName: r.displayName,
          toggleable: r.toggleable,
        }))
        // R.filter(r => r.id),
        // R.map(({ id, resources, displayName }) => ({
        //   id,
        //   resources,
        //   displayName,
        // }))
      )(roles)
    },
    [fuzzyFilter, idNameMap, resourceType, selectedIds, showAll]
  )

  const isAlreadyInRole = useCallback(
    roles => {
      return roles.map(d => d.id).find(id => selectedIds.includes(id))
    },
    [selectedIds]
  )
  const [handValue, setHandString] = useState({})
  const [notFound, setNotFound] = useState({})
  const invertMap = useMemo(
    _ =>
      R.reduce(
        (a, b) => ({ ...a, ...b }),
        {},
        Object.keys(idNameMap).map(k => ({ [idNameMap[k].toLowerCase()]: k }))
      ),
    [idNameMap]
  )
  const onInputAdd = useCallback(
    (key, id) => {
      const valList = handValue[key].split('\n')

      let dataList = valList.map(d => invertMap[d.toLowerCase()])
      const notF = valList.filter(d => !invertMap[d.toLowerCase()])
      setNotFound({ ...notFound, [key]: notF })

      dataList = dataList.filter(f => !!f)

      dataList
        // .filter(k => !selectedIds.includes(k))
        .map(k => id + '$$' + k)
        .forEach(k => {
          if (!selectedIds.includes(k)) onChange(k)()
        })
    },
    [handValue, invertMap, notFound, onChange, selectedIds]
  )

  const onClearAdd = useCallback(
    (key, id) => {
      setNotFound({ ...notFound, [key]: [] })
      setHandString({ ...handValue, [key]: '' })
    },
    [handValue, notFound]
  )

  const getMultiCheckbox = useCallback(
    roles => {
      return (
        <Collapse.Panel
          header={roles[0].displayName}
          style={{
            backgroundColor: isAlreadyInRole(roles) ? 'grey' : undefined,
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns:
                '4fr' + (hasCopyAddFunctinality ? ' 2fr' : ''),
            }}
          >
            <CheckboxListDiv>
              <div style={{ display: 'flex' }}>
                <div style={{ display: 'grid', alignContent: 'center' }}>
                  <Switch
                    checked={
                      showAll[getPrifixId(roles[0].id)] === undefined
                        ? true
                        : showAll[getPrifixId(roles[0].id)] || false
                    }
                    onClick={checked =>
                      setShowAll({
                        ...showAll,
                        [getPrifixId(roles[0].id)]: checked,
                      })
                    }
                    checkedChildren="All visible"
                    unCheckedChildren="Selected visible"
                    style={{ marginRight: '10px' }}
                  />
                </div>
                <Button
                  onClick={e => {
                    const records = roles.map(r => ({
                      id: r.id,
                      resources:
                        resourceType === 'company'
                          ? r.resources.company && r.resources.company[0]
                          : r.resources.station && r.resources.station[0],
                    }))
                    records
                      .filter(r =>
                        (idNameMap[r.resources] + '' + r.resources)
                          ?.toLowerCase()
                          .includes(fuzzyFilter[getPrifixId(r.id)] || '')
                      )
                      .forEach(r => {
                        if (!selectedIds.includes(r.id)) onChange(r.id)()
                      })
                  }}
                >
                  Select All
                </Button>
                <Button
                  style={{ marginLeft: '10px' }}
                  onClick={e => {
                    const records = roles.map(r => ({
                      id: r.id,
                      resources:
                        resourceType === 'company'
                          ? r.resources.company && r.resources.company[0]
                          : r.resources.station && r.resources.station[0],
                    }))
                    records
                      .filter(r =>
                        (idNameMap[r.resources] + '' + r.resources)
                          ?.toLowerCase()
                          .includes(fuzzyFilter[getPrifixId(r.id)] || '')
                      )
                      .forEach(r => {
                        if (selectedIds.includes(r.id)) onChange(r.id)()
                      })
                  }}
                >
                  Clear All
                </Button>
                {roles[0]?.toggleable && (
                  <Input.Search
                    placeholder="Filter"
                    // value={fuzzyFilter}
                    value={fuzzyFilter[getPrifixId(roles[0]?.id)]}
                    css={{
                      marginLeft: '10px',
                      marginRight: '10px',
                      flex: '0 0 200px',
                    }}
                    onChange={e =>
                      setFuzzyFilter({
                        ...fuzzyFilter,
                        [getPrifixId(roles[0]?.id)]: e.target.value,
                      })
                    }
                  />
                )}
              </div>
              <div />
              {resourceTypeSort(
                roles
              ).map(({ id, resources, toggleable, displayName }) =>
                getCheckbox(id, toggleable ? idNameMap[resources] : displayName)
              )}
            </CheckboxListDiv>
            {hasCopyAddFunctinality && (
              <div
                css={{
                  border: '1px solid #eee',
                  padding: '2px',
                  margin: '5px',
                  display: 'grid',
                  gridTemplateRows: '1fr max-content 1fr',
                }}
              >
                <Input.TextArea
                  placeholder="Add Name"
                  style={{
                    gridColumnEnd: 'span 1',
                    // margin: '10px',
                    width: 'auto',
                    padding: '10px',
                  }}
                  value={handValue[roles[0].displayName]}
                  onChange={e =>
                    setHandString({
                      ...handValue,
                      [roles[0].displayName]: e.target.value,
                    })
                  }
                  rows={5}
                />
                <div style={{ display: 'flex', height: 'fit-content' }}>
                  <Button
                    style={{
                      width: 'max-content',
                      marginLeft: '5px',
                      marginTop: '5px',
                    }}
                    onClick={_ =>
                      onInputAdd(
                        roles[0].displayName,
                        roles[0].id.substr(0, roles[0].id.indexOf('$'))
                      )
                    }
                  >
                    Add
                  </Button>
                  <Button
                    style={{
                      width: 'max-content',
                      marginLeft: '5px',
                      marginTop: '5px',
                    }}
                    onClick={_ =>
                      onClearAdd(
                        roles[0].displayName,
                        roles[0].id.substr(0, roles[0].id.indexOf('$'))
                      )
                    }
                  >
                    Clear
                  </Button>
                  {notFound.length > 0 && (
                    <div
                      style={{
                        minWidth: '200px',
                        marginLeft: '30px',
                        display: 'grid',
                        alignContent: 'center',
                      }}
                    >
                      Below Names not found
                    </div>
                  )}
                </div>

                <div
                  style={{
                    overflow: 'auto',
                    width: 'auto',
                    display: 'grid',
                    maxHeight: '150px',
                    alignContent: 'baseline',
                    padding: '2px',
                    margin: '5px',
                    border: '1px solid #eee',
                  }}
                >
                  {(notFound[roles[0].displayName] || []).map(c => (
                    <div key={c} style={{ color: 'red' }}>
                      {c}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </Collapse.Panel>
      )
    },
    [
      getCheckbox,
      handValue,
      hasCopyAddFunctinality,
      idNameMap,
      isAlreadyInRole,
      notFound,
      onChange,
      onClearAdd,
      onInputAdd,
      resourceTypeSort,
      selectedIds,
      showAll,
      fuzzyFilter,
      resourceType,
    ]
  )

  const sort = d => R.sort((a, b) => a.localeCompare(b), d)

  const renderCheckBoxList = useCallback(
    _ => {
      const singleRoles = sort(
        Object.keys(dataMap).filter(k => dataMap[k].length === 1)
      )
      const multiRoles = sort(
        Object.keys(dataMap)
        // .filter(k => dataMap[k].length !== 1)
      )

      const singleCheckBoxs = singleRoles.length && (
        <Collapse.Panel
          header="Single Role Selection"
          style={{
            backgroundColor: isAlreadyInRole(
              R.flatten(singleRoles.map(id => dataMap[id]))
            )
              ? 'grey'
              : undefined,
          }}
        >
          <CheckboxListDiv>
            {singleRoles.map(k => {
              const roles = dataMap[k]
              const {
                toggleable,
                sameId = k,
                displayName,
                id,
                resources,
                shifts,
              } = roles[0]
              const { company, station } = resources

              if (toggleable && shifts === 'COMPANY')
                return getCheckbox(
                  id,
                  displayName + ' ( ' + companyNameMap[company[0]] + ' )'
                )
              if (toggleable && shifts === 'STATION')
                return getCheckbox(
                  id,
                  displayName + ' ( ' + stationNameMap[station[0]] + ' )'
                )
              if (!toggleable)
                return (
                  <Popover
                    key={id}
                    content={
                      <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                        {(company || station || []).map(c => (
                          <div key={c}>
                            {companyNameMap[c] || stationNameMap[c] || c}
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <div style={{ width: 'fit-content' }}>
                      {getCheckbox(id, displayName)}
                    </div>
                  </Popover>
                )
            })}
          </CheckboxListDiv>
        </Collapse.Panel>
      )

      const multiCheckbox = multiRoles.map(k => getMultiCheckbox(dataMap[k]))
      return R.flatten([
        // singleCheckBoxs,
        multiCheckbox,
      ])
    },
    [
      companyNameMap,
      dataMap,
      getCheckbox,
      getMultiCheckbox,
      isAlreadyInRole,
      stationNameMap,
    ]
  )

  return (
    <div style={{ height, maxHeight: height, overflow: 'auto' }}>
      <Collapse accordion>{renderCheckBoxList()}</Collapse>
    </div>
  )
}

const mapStateToProps = state => ({
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  companyNameMap: getCompanyNameMap(state),
  stations: getStations(state),
})
export default connect(mapStateToProps)(RoleTypeSelection)
